// Include external
// js error logger
Raven.config("https://f4867f3c62ff4bf9a1f3f30f9c7edfca@sentry.io/144537", {
    whitelistUrls: [
        /\/assets\//
    ]
}).install();